"use strict";

/**
* Контекстное меню в виде горизонтально расположенных иконок.
*
* @class WebAccess.components.menus.OnlyIconsContextMenu
* @since 5.0.0.4200
* @extends WebAccess.components.menus.BaseContextMenu
* @param {string} itemSelector Существующий элемент страницы
* @param {WebAccess.components.menus.BaseContextMenu.contextMenuItem} [opt_menuItems] Массив со списком пунктов меню
* @param {WebAccess.components.menus.BaseContextMenu.contextMenuSettings} [opt_settings] Параметры контекстного меню
* @param {string} [opt_settings] ИД элемента страницы
* @property  WebAccess.components.menus.OnlyIconsContextMenu#jMenu  jQuery элемент текущего отрисованного меню
* @property  WebAccess.components.menus.OnlyIconsContextMenu#controlId  ИД элемента на страницы
* @example
* // При наведении мыши на логотип Directum откроется контекстное меню.
* var menu = new window.WebAccess.components.menus.OnlyIconsContextMenu("#logo", [{
*        name: "itemName",
*        text: "text",
*        image: "ToolbarAndTab/SaveAndExit_16.png",
*        imageCSSClass: "availableStatuses[i]",
*        selected: true
*      }], {}, "menuId");
* menu.render();
*
* menu.bind('itemSelect', function (item) {
*  console.log(item);
* });
*
* $("#logo").hover(function() { menu.show() },function() { menu.hide() } );
*/
(function (global) {
  var OnlyIconsContextMenu = global.BaseContextMenu.extend({
    init: function (element, opt_menuItems, opt_settings, opt_controlId) {
      var me = this;
      me._super(element, opt_menuItems, opt_settings);
      me.controlId = opt_controlId || 'onlyIconsContextMenu';
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    className: 'OnlyIconsContextMenu',
    controlId: 'onlyIconsContextMenu',
    jMenu: null,

    /**
     * Отобразить контекстое меню.
     * Метод может быть вызван только один раз – когда все пункты меню уже переданы.
     * @method WebAccess.components.menus.OnlyIconsContextMenu#render
     * @throws ERR_OBJECT_IS_ALREADY_RENDERED - объект уже отображен.
     * @return {WebAccess.components.menus.OnlyIconsContextMenu} Oбъект типа OnlyIconsContextMenu.
     */
    render: function (force) {
      var me = this;
      var i;
      if (!!me._isRendered && !force) return WA.raise("ERR_OBJECT_IS_ALREADY_RENDERED");

      // Удяляем элемент с таким ИД.
      $('#' + me.controlId).remove();

      // Генерируем HTML.
      var html = '<div id="' + me.controlId + '" class="contextmenu contextmenu_only-icons only-icons-menu ' + (!me.settings.isHorizontal || me.settings.isHorizontal === true ? 'horizontal' : 'vertical') + '">';
      for (i = 0; i < me.items.length; i++) {
        html += '<div data-name="' + me.items[i].name + '" title="' + me.items[i].text + '" class="contextmenu_only-icons__item item ' + (me.items[i].selected ? 'selected' : '') + '">';
        html += '<div class="contextmenu_only-icons__status ' + me.items[i].image + '"></div>';
        html += '</div>';
      }
      html += '</div>';
      me.jMenu = $(html);

      // Навешиваем события на элементы списка.
      var itemEls = me.jMenu.find('.item');
      for (i = 0; i < me.items.length; i++) {
        var onClick = (function (item) {
          return function () {
            me.jMenu.find('.selected').removeClass('selected');
            $(this).addClass('selected');
            me.fire("itemSelect", item);
          };
        })(me.items[i]);
        itemEls.eq(i)
          .on('click.onlyIconsCM', onClick);
      }
      me._isRendered = true;

      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Отобразить меню в координатах переданного элемента.
     * @method WebAccess.components.menus.OnlyIconsContextMenu#show
     * @return {WebAccess.components.menus.OnlyIconsContextMenu} Oбъект типа OnlyIconsContextMenu.
     */
    show: function () {
      var me = this;
      if ($('#' + me.controlId).length === 0) {
        $('body').append(me.jMenu);
      }
      var jObjOffset = me._jObject.offset();
      me.jMenu.css({
        'position': 'absolute',
        'left': Math.round(jObjOffset.left),
        'top': Math.round(jObjOffset.top)
      });
      me.jMenu.show();
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Отобразить меню в переданном элементе.
     * @method WebAccess.components.menus.OnlyIconsContextMenu#showIn
     * @param {string} container Селектор или контейнер
	   * @param {boolean} atTop Признак, выше или ниже контейнера должно быть вставлено меню
     * @return {WebAccess.components.menus.OnlyIconsContextMenu} Oбъект типа OnlyIconsContextMenu.
     */
    showIn: function (container, atTop) {
      var me = this;
      if (atTop === true) {
        $(container).prepend(me.jMenu);
      } else {
        $(container).append(me.jMenu);
      }
      me.jMenu.show();
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Скрыть контекстное меню.
     * @method WebAccess.components.menus.OnlyIconsContextMenu#hide
     * @return {WebAccess.components.menus.OnlyIconsContextMenu} Oбъект типа OnlyIconsContextMenu.
     */
    hide: function () {
      this.jMenu.hide();
      return me;
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  });

  global.OnlyIconsContextMenu = OnlyIconsContextMenu;
})(window.WebAccess.components.menus);